module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFcAAAACCAYAAAAti0AoAAAAqklEQVQoke2QSW4AQQgDa9om/3/vsOXQ84XcYglRRkZIPIgFePTcOg+SkIWPiDCWkUX4B0cQEuFANuHAYX4c2HHzNnYgmYggIpD0ZYwkHEa6c9uEdO9KSOacw9HhnIMf8eiwu3Q3s8PMMD3XT1NddA/VTVVRVXQX/XH21/Olu8ksqpKq/Pj67OJ937tfSXaTVXQm2Xm5iuohK9lqeoatZRd2lvtROPzrz/QLdjd/Bbs42b0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/de-grad.png
// module id = 54
// module chunks = 0